<template>


<div style="margin: 5px;">
    <InputGroup>
    <InputGroupAddon>Company Name(English)</InputGroupAddon>
    <InputText placeholder="Company Name(English)" v-model="value"   :required="required"  :disabled="disabled"  :class="{'p-invalid': isError}" />
 </InputGroup>
</div>

    
</template>  
<script>

export default {
    props: ["modelValue", 'disabled','required'],
    emits: ["update:modelValue"],
    components: {

    },
    data() {
        return {
            value: "EN company name"
        }
    },
    created() {
        this.value = this.modelValue
    },
    mounted(){
        this.value = (this.modelValue);
        this.$emit("update:error", this.isError);
      },
      computed:{
        isError(){
            return  !this.value && this.required;
        }
    },
    watch: {
            value: function (newVal, oldVal) {
              // watch it
              console.log("Prop changed: ", newVal, " | was: ", oldVal);
              this.$emit("update:modelValue", newVal );
              this.$emit("update:error", this.isError);
            },
          },
}
</script>
  
  